const text = `
&nbsp

Sample Workout Data details in JSON format

~~~
    {
        "datetime": "2026-01-01T01:01:01.111Z",
        "userId": "Anonymous",
        "workout_airForcePRTScore": 0,
        "workout_airTime": 0.0,
        "workout_averageAirTime": 0.0,
        "workout_averageCadence": 0.0,
        "workout_averageGroundContact": 0.0,
        "workout_averageLeftRightBalance": 0.0,
        "workout_avgHeartRate": 0,
        "workout_avgIncline": 0.0,
        "workout_avgLevel": 0.0,
        "workout_avgMets": 2.762623176,
        "workout_avgRpm": 0.0,
        "workout_avgSpeed": 2.308,
        "workout_avgStride": 0.0,
        "workout_avgStridesPerMin": 0.0,
        "workout_avgWatts": 38,
        "workout_cadence": 0,
        "workout_calories": 2,
        "workout_caloriesPerHour": 156,
        "workout_completeWorkoutTime": 0.7667,
        "workout_cooldownTimeRemaining": 0.0,
        "workout_currentIncline": 0.0,
        "workout_currentLevel": -1,
        "workout_currentSpeed": 3.29,
        "workout_cushioning": 121,
        "workout_distance": 147.3304,
        "workout_distanceClimbed": 0.0,
        "workout_groundContact": 0.0,
        "workout_heartRate": 0,
        "workout_leftRightBalance": 50.0,
        "workout_maxHeartRate": 0,
        "workout_maxStride": 0.0,
        "workout_mets": 4.086097,
        "workout_rank": 0,
        "workout_recoveryHR": 0,
        "workout_rpm": 0,
        "workout_score": 0,
        "workout_stride": 0.0,
        "workout_summaryTotalWorkoutTime": 0,
        "workout_targetHeartRate": 0,
        "workout_timeElapsed": 46.0,
        "workout_timeElapsedSeconds": 46,
        "workout_timeElapsedString": "0:46",
        "workout_timeGoalInCoolDown": 0.0,
        "workout_timeInCoolDown": 46.0,
        "workout_timeInZoneString": "0:00",
        "workout_totalSteps": 0,
        "workout_totalWattSecondsSaved": 0,
        "workout_totalWorkoutTime": 0.0,
        "workout_watts": 68
    }
~~~
`;

export default text;



// WEBPACK FOOTER //
// ./src/components/guides/RealTimeAvailability/RealTimeAvailabilityText4.js